import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SageReviewGroupKind } from '../../../../shared/services/sage-integration.model';

export interface ReviewGroup {
  key: string;
  kind: SageReviewGroupKind;
  entityType: number;
  label: string;
  count: number;
  examples: string[];
  action: string;
}

@Component({
  selector: 'app-sage-review-column',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './review-column.component.html',
  styleUrls: ['./sage-work-column.css'],
})
export class SageReviewColumnComponent {
  @Input() groups: ReviewGroup[] = [];
  @Input() totalCount = 0;
  @Input() loading = false;

  @Output() openQueue = new EventEmitter<void>();
  @Output() openGroup = new EventEmitter<ReviewGroup>();

  readonly trackGroup = (_: number, g: ReviewGroup) => g.key;

  examplesLabel(group: ReviewGroup): string {
    if (!group.examples.length) return '';
    const shown = group.examples.join(', ');
    const rest = group.count - group.examples.length;
    return rest > 0 ? `${shown} and ${rest} more` : shown;
  }
}
